<div class="contant-dialog">
    <div class="orang-title textAlignCenter"> רשימת סטטוסים לרשויות</div>

    <div *ngIf="data?.length>0">
        <table class="table">
            <thead>
                <tr>
                    <th scope="col">רשות</th>
                    <th scope="col">סטטוס</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of data">
                    <td>{{item.Authority}}</td>
                    <td>{{item.Status}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="textAlignCenter noData" *ngIf="!data||data.length==0">
        <span>אין מידע</span>
    </div>
    <div class="contant-buttons d-flex justify-content-end">
        <button class="cancel-save-button" (click)="close()">
            <span>סגור</span>
        </button>
    </div>
</div>